import { authedEndpoint } from "../../builder";
import { productionExportResponse } from "../../schemas/production-export";

export const list = authedEndpoint.query(
    () => ({
        url: "export-settings",
    }),
    {
        output: productionExportResponse,
    },
);
